import React, { useState } from 'react';
import { Document } from '../../../interfaces/customer-api';
import css from './StockEquipmentDocuments.module.scss';
import { Spinner } from '../Spinner/Spinner';

export interface PictureItemProps {
    doc: Document;
    onClick: () => void;
}

export const PictureItem: React.FC<PictureItemProps> = ({ doc, onClick }) => {
    const [aspectRatio, setAspectRatio] = useState<number | undefined>(undefined);
    const [isLoaded, setIsLoaded] = useState(false);

    const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
        const { naturalWidth, naturalHeight } = e.currentTarget;
        if (naturalHeight > 0) {
            setAspectRatio(naturalWidth / naturalHeight);
        }
        setIsLoaded(true);
    };

    return (
        <button
            className={css.pictureItem}
            title={doc.name}
            onClick={onClick}
            style={{ aspectRatio: isLoaded ? aspectRatio : 1.5 }}
        >
            {!isLoaded && (
                <div className={css.pictureItemSpinner}>
                    <Spinner size={2} />
                </div>
            )}
            <img src={doc.url} alt={doc.name} onLoad={handleLoad} style={{ display: isLoaded ? 'block' : 'none' }} />
        </button>
    );
};
